import { useState } from "react";
import { useAuth } from "./AuthContext";
import { useNavigate } from "react-router-dom";
import {
  Container,
  TextField,
  Button,
  Typography,
  Card,
  CardContent,
  Alert,
  Snackbar,
  Box,
} from "@mui/material";
import { Lock } from "@mui/icons-material";

const Login = () => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState(null);
  const [openSnackbar, setOpenSnackbar] = useState(false);

  const { login } = useAuth();
  const navigate = useNavigate();

  const handleLogin = async (e) => {
    e.preventDefault();
    setError(null);

    try {
      await login(email, password);
      setOpenSnackbar(true);
      setTimeout(() => navigate("/"), 1000);
    } catch (error) {
      setError("Login fehlgeschlagen. Bitte überprüfe deine Zugangsdaten.");
      console.error("Login Error:", error);
    }
  };

  return (
    <Box
      sx={{
        minHeight: "100vh",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      <Container maxWidth="xs">
        <Box sx={{ textAlign: "center", mb: 4 }}>
          <img
            src="https://www.bmwopen.de/wp-content/uploads/2024/02/Ebene_1-2.svg"
            alt="BMW Open Logo"
            style={{ width: 160, marginBottom: 8 }}
          />
        </Box>

        <Card elevation={0} sx={{ p: 1 }}>
          <CardContent>
            <Box sx={{ display: "flex", flexDirection: "column", alignItems: "center", mb: 3 }}>
              <Box
                sx={{
                  width: 56,
                  height: 56,
                  borderRadius: "50%",
                  bgcolor: "primary.main",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  mb: 2,
                }}
              >
                <Lock sx={{ color: "white", fontSize: 28 }} />
              </Box>
              <Typography variant="h5">Anmelden</Typography>
              <Typography variant="body2" color="text.secondary" sx={{ mt: 0.5 }}>
                Verwaltung
              </Typography>
            </Box>

            {error && (
              <Alert severity="error" sx={{ mb: 2 }}>
                {error}
              </Alert>
            )}

            <form onSubmit={handleLogin}>
              <TextField
                label="E-Mail"
                variant="outlined"
                fullWidth
                margin="normal"
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
              />
              <TextField
                label="Passwort"
                variant="outlined"
                fullWidth
                margin="normal"
                type="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                required
              />

              <Button
                type="submit"
                variant="contained"
                color="primary"
                fullWidth
                size="large"
                sx={{ mt: 3, py: 1.5 }}
              >
                Einloggen
              </Button>
            </form>
          </CardContent>
        </Card>

        <Snackbar
          open={openSnackbar}
          autoHideDuration={2000}
          onClose={() => setOpenSnackbar(false)}
          message="Login erfolgreich!"
        />
      </Container>
    </Box>
  );
};

export default Login;
